import React, { useState } from "react";
import "./IEAccount.css";

import IEDashboard       from "./IEDashboard";
import JournalEntriesTab from "./JournalEntriesTab";
import IEReport          from "./IEReport";

const TABS = [
  { key: "dashboard", label: "Dashboard" },
  { key: "journal",   label: "Journal Entries" },
  { key: "report",    label: "I&E Report" },
];

export default function IEAccount({ societyId, fyId, financialYear }) {

  const [activeTab, setActiveTab] = useState("dashboard");

  const renderTab = () => {
    switch (activeTab) {
      case "dashboard":
        return (
          <IEDashboard
            societyId={societyId}
            fyId={fyId}
            financialYear={financialYear}
            onGoToReport={() => setActiveTab("report")}
            onGoToJournal={() => setActiveTab("journal")}
          />
        );
      case "journal":
        return (
          <JournalEntriesTab
            societyId={societyId}
            fyId={fyId}
            financialYear={financialYear}
          />
        );
      case "report":
        return (
          <IEReport
            societyId={societyId}
            fyId={fyId}
            financialYear={financialYear}
          />
        );
      default:
        return null;
    }
  };

  return (
    <div className="ie-page">

      <div className="ie-fy-bar">
        <span className="ie-fy-label">Financial Year</span>
        <span style={{ fontSize: 15, fontWeight: 600, color: "#2a221c" }}>
          {financialYear}
        </span>
      </div>

      <div className="ie-tabs">
        {TABS.map((tab) => (
          <button
            key={tab.key}
            className={`ie-tab${activeTab === tab.key ? " active" : ""}`}
            onClick={() => setActiveTab(tab.key)}
          >
            {tab.label}
          </button>
        ))}
      </div>

      {renderTab()}

    </div>
  );
}
